// extracted by mini-css-extract-plugin
export var linkText = "ProjectsPageLink-module--link-text--CMZ5N";
export var link = "ProjectsPageLink-module--link--2i2ea";
export var linkImage = "ProjectsPageLink-module--link-image--HASra";